import { FadeBanner } from '@/components/banners/FadeBanner';
import { outOfBandThemeColors } from '@/theme/colors';
import { Box } from '@montugroup/design-system';
import { styled, useMediaQuery, useTheme } from '@mui/material';

const OnboardingHeaderContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: outOfBandThemeColors.uMeds.sunshade200,
}));

const BannerItem = styled(Box)(({ theme }) => ({
  padding: `${theme.spacing(3)} 0`,
  [theme.breakpoints.up('sm')]: {
    padding: `${theme.spacing(3)} ${theme.spacing(6)}`,
  },
}));

const BANNER_MESSAGES = [
  '📦 Delivered discreetly',
  '🩺 Partnered with 130+ pharmacies',
  '🚚 Fast and reliable delivery',
];

export function OnboardingBanner() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <OnboardingHeaderContainer>
      {isMobile ? (
        <FadeBanner>
          {BANNER_MESSAGES.map((item) => (
            <BannerItem key={item}>{item}</BannerItem>
          ))}
        </FadeBanner>
      ) : (
        <>
          {BANNER_MESSAGES.map((item) => (
            <BannerItem key={item}>{item}</BannerItem>
          ))}
        </>
      )}
    </OnboardingHeaderContainer>
  );
}
